import React from "react";
import tw from "twin.macro";

import { motion } from "framer-motion";
import useInView from "helpers/useInView";

const StyledDiv = tw.main`font-display min-h-screen text-secondary-500 p-8 pt-24 overflow-hidden`;
function AnimationReveal({ disabled, children }) {
  if (disabled) {
    return <>{children}</>;
  }

  if (!Array.isArray(children)) children = [children];

  const childrenWithAnimation = children.map((child, i) => {
    return (
      <AnimatedFadeInComponent key={i}>
        {child}
      </AnimatedFadeInComponent>
    );
  });
  return <>{childrenWithAnimation}</>;
}

function AnimatedFadeInComponent({ children }) {
  const [ref, inView] = useInView({ margin: "-30px 0px 0px 0px" });

  return (
    <div ref={ref}>
      <motion.section
        initial={{ opacity: 0, y: 40 }}
        animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 40 }}
        transition={{ duration: 0.5, ease: "easeOut" }}
        style={{ willChange: "opacity, transform" }}
      >
        {children}
      </motion.section>
    </div>
  );
}

export default props => (
  <StyledDiv className="App" id="main-content">
    <AnimationReveal {...props} />
  </StyledDiv>
);
